import { render, staticRenderFns } from "./ifo.vue?vue&type=template&id=592d35f4&scoped=true&"
import script from "./ifo.vue?vue&type=script&lang=js&"
export * from "./ifo.vue?vue&type=script&lang=js&"
import style0 from "./ifo.vue?vue&type=style&index=0&id=592d35f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592d35f4",
  null
  
)

export default component.exports